export const GSHEET_SRIPT = "https://script.google.com/macros/s/AKfycbwWONeSZdxS6ACSWdezGbFpr5L6G7Dii1dIwb1T-YNknlMYxBhtqaUpJ3mrqpaGOvnAgw/exec";
export const GA_MEASUREMENT_ID = "G-QWBKN15YMW";
export const OTP_API_URI = "https://z9f5u8qp77.execute-api.ap-southeast-1.amazonaws.com/prd/graphql";
export const ENVIRONMENT = "PROD";